import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { instrumentedFetch } from './instrumentedFetch';

// .trim() is load-bearing: the Vercel env var carries a trailing CRLF, which
// URL-encodes into the realtime WebSocket URL (…%0D%0A) and makes every
// realtime connection fail auth.
export const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL ?? '').trim();
const SUPABASE_PUBLISHABLE_KEY = (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '').trim();

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Missing Supabase environment configuration');
}

// Capped exponential backoff with jitter so a fleet of tabs does not
// reconnect in lockstep after a realtime outage.
const reconnectAfterMs = (tries: number) =>
  Math.min(1000 * 2 ** tries, 60_000) + Math.floor(Math.random() * 1000);

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: instrumentedFetch,
  },
  realtime: {
    params: { eventsPerSecond: 5 },
    worker: true,
    reconnectAfterMs,
  },
});
